import PropTypes from 'prop-types';
import { TypographyWrapper } from '@bwoty-web/ui-kit';

const FakeHotelView = ({ description }) => {
  return (
    <TypographyWrapper className="uikit-box">
      <h1>{description.header}</h1>
      <div
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: description.content }}
      />
    </TypographyWrapper>
  );
};

FakeHotelView.propTypes = {
  description: PropTypes.shape({
    header: PropTypes.string,
    content: PropTypes.string,
  }).isRequired,
};

export default FakeHotelView;
